import type { FC } from "react";

interface Props {
  icon: string;
  count: number | null;
}

// AIDEV-NOTE: `icon` je URL na asset (vite `?url`), ne svgr komponenta. Odznaků je 34 a jako
// inline komponenty tvořily 13 % vstupního chunku (422 kB raw / 81 kB gzip) — táhl je tam
// Dashboard přes NewestBadges → badgesConfiguration. Náhrada je bezpečná, protože jsou to
// barevné ilustrace bez `currentColor` a `_achievement.scss` cílí párově `> img, > svg`.
const AchievementIcon: FC<Props> = ({ icon, count }) => (
  <div>
    <img src={icon} alt="" />
    {count !== null && count > 0 ? <div className="achievement__badge">{count}x</div> : null}
  </div>
);

export default AchievementIcon;
